// extracted by mini-css-extract-plugin
module.exports = {"p-grid-columns":"availability-by-source-content_p-grid-columns__VmvAN","span--text-end":"availability-by-source-content_span--text-end__NYZHq"};